import styled from 'styled-components';

export const Wrapper = styled.button<{
  width: string;
  minHeight: string;
  bg: string;
  textColor: string;
  borderColor: string;
  hoverBg: string;
  hoverTextColor: string;
  disabled: boolean;
  style: React.CSSProperties | undefined;
}>`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 16px;
  text-align: center;
  background: ${({ bg }) => bg};
  color: ${({ textColor }) => textColor};
  min-height: ${({ minHeight }) => minHeight};
  width: ${({ width }) => width};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  padding: 6px;
  outline: none;
  border: none;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  border: ${({ borderColor }) => '1px solid ' + borderColor};
  transition: transform 0.1s ease-out, opacity 0.1s ease-in-out, background 0.1s ease-in-out,
    color 0.1s ease-in-out;

  &:hover {
    color: ${({ hoverTextColor }) => hoverTextColor};
    background: ${({ hoverBg }) => hoverBg};
  }
`;
